import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';

// service
import { AppService } from 'src/app/shared/service/app/app.service';

// i18n
import { TranslateModule } from '@ngx-translate/core';

// perfect-scrollbar
import { NgScrollbarModule, provideScrollbarOptions } from 'ngx-scrollbar';

// headlessui
import { MenuModule } from 'headlessui-angular';

// icons
import { IconModule } from 'src/app/shared/icon/icon.module';

// pipes
import { Nl2BrPipe } from 'src/app/shared/pipes/nl2br.pipe';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule.forChild(), NgScrollbarModule, MenuModule, IconModule],
  declarations: [Nl2BrPipe],
  exports: [
    // modules
    FormsModule,
    ReactiveFormsModule,

    TranslateModule,
    NgScrollbarModule,
    MenuModule,
    IconModule,

    // pipes
    Nl2BrPipe,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: [
        Title,
        AppService,
        provideScrollbarOptions({
          visibility: 'hover',
          appearance: 'compact',
        }),
      ],
    };
  }
}
